import angular from 'angular';

import {} from './od-press-coverage.less';

module.exports = angular.module('market.components.od-press-coverage', [])
.component('odPressCoverage', {
  template: require('./od-press-coverage.jade')(),
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-press-coverage.js
 **/